import React, { useContext, useState, useEffect, useRef } from 'react';
import cn from 'classnames';
import { Url } from '@wix/da-url';
import { useBiLogger } from '@wix/da-bi/pkg/hooks/useBiLogger';
import { BiData } from '@wix/da-bi/pkg/events';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import NotificationCounter from '@wix/da-ds/pkg/Indicators/NotificationCounter';
import NotificationIcon from '@wix/da-ds/pkg/Icons/24x24/Notification';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import FakeDrawer from './_partials/FakeDrawer';
import s from './AnonJoinFakeNotification.scss';
const AnonJoinFakeNotification = ({ className  })=>{
    const [isOpen, setIsOpen] = useState(false);
    const firstTimeOpenRef = useRef(true);
    const isMobile = useContext(MobileContext);
    const biLogger = useBiLogger();
    // Fire bi event the first time the drawer is opened
    useEffect(()=>{
        if (isOpen && firstTimeOpenRef.current) {
            biLogger(BiData({
                evid: 99,
                view: 'notifications',
                component: 'header'
            }));
            firstTimeOpenRef.current = false;
        }
    }, [
        isOpen,
        biLogger
    ]);
    return /*#__PURE__*/ React.createElement("div", {
        className: cn(s['root'], className),
        onClick: isMobile ? ()=>setIsOpen(!isOpen) : undefined,
        onMouseEnter: !isMobile ? ()=>setIsOpen(true) : undefined,
        onMouseLeave: !isMobile ? ()=>setIsOpen(false) : undefined
    }, /*#__PURE__*/ React.createElement(PlainButtonOrLink, {
        href: isMobile ? undefined : Url.joinLink()
    }, /*#__PURE__*/ React.createElement(NotificationIcon, {
        className: s['notifications-icon'],
        size: IconSize.MEDIUM
    }), /*#__PURE__*/ React.createElement(NotificationCounter, {
        className: s['counter']
    }, "1")), /*#__PURE__*/ React.createElement("div", {
        role: "dialog",
        id: "site-header-notifications",
        className: cn(s['drawer-container'], isOpen && s['active'])
    }, isOpen && /*#__PURE__*/ React.createElement(FakeDrawer, null)));
};
AnonJoinFakeNotification.displayName = 'AnonJoinFakeNotification';
export default AnonJoinFakeNotification;
